module.exports = __webpack_public_path__ + "img/Filled bookmark.9a6d7275.svg";